import React, { ComponentProps, useCallback } from 'react';
import { useIntl } from 'react-intl';
import ym from 'react-yandex-metrika';

import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';
import { DetectPasteTumbler } from '@edu-frontend/modules/src/features/pastesHistory';

import { useBunkerOnboarding, DETECT_PASTE_ONBOARDING_KEY } from 'hooks/useBunkerOnboarding';

export interface TeacherDetectPasteTumblerProps extends Partial<ComponentProps<typeof DetectPasteTumbler>> {
    fromOrigin: 'course_journal' | 'student_stat_journal' | 'results';
}

export const TeacherDetectPasteTumbler = (props: TeacherDetectPasteTumblerProps) => {
    const intl = useIntl();

    const getIntlText = useCallback(
        (id: string, values: Record<string, string>) => intl.formatMessage({ id }, values),
        [intl]
    );

    const { openOnboarding } = useBunkerOnboarding({ id: DETECT_PASTE_ONBOARDING_KEY });
    const onTooltipLinkClick = useCallback(() => openOnboarding(), [openOnboarding]);

    const onMount = React.useCallback(
        (toggleState: boolean) => {
            ym('reachGoal', 'teacher_copypaste_detector_shown', {
                copypaste_detector_state: toggleState,
                from: props.fromOrigin,
            });
        },
        [props.fromOrigin]
    );

    const onToggle = React.useCallback(
        (toggleState: boolean) => {
            ym('reachGoal', 'teacher_copypaste_detector_toggle', {
                copypaste_detector_state: toggleState,
                from: props.fromOrigin,
            });
        },
        [props.fromOrigin]
    );

    return (
        <DetectPasteTumbler
            getIntlText={getIntlText}
            onMount={onMount}
            onToggle={onToggle}
            onTooltipLinkClick={onTooltipLinkClick}
            theme={hrLight}
            {...props}
        />
    );
};
